import { Users, Leaf, Eye } from "lucide-react";
import { t, tf } from "@/lib/i18n";
import Reveal from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";

const POINTS = [
  { icon: Users, title: "Kabadiwalas already do the hard work", body: "In most Indian cities, local kabadiwalas quietly collect and pass on a large share of what gets recycled. We want to make their work easier to find." },
  { icon: Leaf, title: "Sorted waste gets a second life", body: "Paper, plastic and metal that are kept clean and separate can be recycled. Mixed with wet waste, they usually end up in a landfill." },
  { icon: Eye, title: "Fair and transparent for both sides", body: "Published indicative rates and weighing at your door help build trust between you and your kabadiwala." },
];

export default function WhyItMatters() {
  const { content } = useSite();
  return (
    <section className="bg-[var(--leaf)] text-white grain my-12" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--marigold)]">{t("Why Kindsaver")}</div>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">{t("We're not reinventing recycling. We're connecting it.")}</h2>
          <p className="mt-5 text-[#DCEBD8] leading-relaxed">{tf("Kindsaver is just getting started. Our first step is simple: make it easy for anyone in {city} to reach a local kabadiwala.", { city: content.launch_city })}</p>
        </Reveal>
        <div className="lg:col-span-7 space-y-4">
          {POINTS.map(({ icon: Icon, title, body }, i) => (
            <Reveal key={t(title)} delay={i * 100} className="flex gap-5 p-6 rounded-3xl bg-white/[.07] border border-white/10 hover:bg-white/[.11] transition-colors">
              <span className="w-12 h-12 rounded-2xl bg-[var(--marigold)] text-[var(--ink)] flex items-center justify-center shrink-0"><Icon size={22} /></span>
              <div>
                <h3 className="text-lg sm:text-xl font-bold">{t(title)}</h3>
                <p className="mt-2 text-sm sm:text-base text-[#DCEBD8] leading-relaxed">{t(body)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
